import React from "react";

const PublishedIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38.883"
      height="33.767"
      viewBox="0 0 38.883 33.767"
    >
      <g
        id="Group_1154"
        data-name="Group 1154"
        transform="translate(-2.5 -8.7)"
      >
        <path
          id="Path_1242"
          data-name="Path 1242"
          d="M46.915,47.165,42.085,40.9a1.423,1.423,0,0,0-2.251,0l-4.871,6.262a1.424,1.424,0,0,0,1.146,2.292h2.456V60.344a.821.821,0,0,0,.819.819h3.111a.821.821,0,0,0,.819-.819V49.457h2.456A1.424,1.424,0,0,0,46.915,47.165Z"
          transform="translate(-18.998 -18.696)"
          fill={fill ? fill : "#34b7fb"}
        />
        <path
          id="Path_1243"
          data-name="Path 1243"
          d="M38.6,8.7H5.283A2.786,2.786,0,0,0,2.5,11.483V36.491a2.821,2.821,0,0,0,2.783,2.824H15.475a.629.629,0,0,0,.614-.614V36.368a.629.629,0,0,0-.614-.614H6.225a.193.193,0,0,1-.2-.2V16.968H37.863V35.59a.219.219,0,0,1-.2.2h-9.25a.629.629,0,0,0-.614.614v2.333a.629.629,0,0,0,.614.614H38.6a2.786,2.786,0,0,0,2.783-2.783V11.524A2.8,2.8,0,0,0,38.6,8.7ZM7.166,14.021a1.187,1.187,0,1,1,1.187-1.187A1.188,1.188,0,0,1,7.166,14.021Zm3.643,0a1.223,1.223,0,0,1-1.228-1.187,1.208,1.208,0,0,1,2.415,0A1.162,1.162,0,0,1,10.809,14.021Zm3.684,0a1.187,1.187,0,1,1,0-2.374,1.223,1.223,0,0,1,1.228,1.187A1.251,1.251,0,0,1,14.492,14.021Z"
          fill={fill ? fill : "#34b7fb"}
        />
      </g>
    </svg>
  );
};

export default PublishedIcon;
